// Category color language for planogram tiles + badges.
export const CATEGORIES = [
  "Soda", "Energy", "Sports", "Water", "Juice", "Tea", "Chips", "Candy", "Protein", "Other",
];

export const CATEGORY_COLORS = {
  Soda: { bg: "#E6F6FB", stripe: "#0E7490", text: "#0B1220" },
  Energy: { bg: "#FFF7ED", stripe: "#D97706", text: "#0B1220" },
  Sports: { bg: "#F0FDFA", stripe: "#0D9488", text: "#0B1220" },
  Water: { bg: "#EFF6FF", stripe: "#2563EB", text: "#0B1220" },
  Juice: { bg: "#ECFDF5", stripe: "#059669", text: "#0B1220" },
  Tea: { bg: "#FEFCE8", stripe: "#A16207", text: "#0B1220" },
  Chips: { bg: "#F5F3FF", stripe: "#4F46E5", text: "#0B1220" },
  Candy: { bg: "#FFF1F2", stripe: "#E11D48", text: "#0B1220" },
  Protein: { bg: "#F0FDF4", stripe: "#65A30D", text: "#0B1220" },
  Other: { bg: "#F1F5F9", stripe: "#334155", text: "#0B1220" },
};

export const catColor = (c) => CATEGORY_COLORS[c] || CATEGORY_COLORS.Other;

export const abbrev = (name, len = 12) => {
  if (!name) return "";
  return name.length > len ? name.slice(0, len - 1) + "\u2026" : name;
};

export const confLevel = (c) => (c >= 0.8 ? "high" : c >= 0.55 ? "medium" : "low");

export const CONF_STYLE = {
  high: { bg: "#ECFDF5", border: "#34D399", text: "#065F46", label: "High" },
  medium: { bg: "#FFFBEB", border: "#FBBF24", text: "#92400E", label: "Medium" },
  low: { bg: "#FEF2F2", border: "#FCA5A5", text: "#991B1B", label: "Low" },
};

// Common warehouse/retail stores that use their own item numbers.
export const ITEM_NUMBER_STORES = ["Vistar", "Costco", "Walmart", "Sam's Club", "Target"];

// Deal judgement for a single captured price vs the shared (weighted) average.
// Green = a good buy (below avg), Red = pricey (above avg), Neutral (null) inside
// a small band around the average. `band` is a fraction (default 5%).
export const dealSticker = (unitPrice, avg, band = 0.05) => {
  if (unitPrice == null || avg == null || avg <= 0) return null;
  const diff = (unitPrice - avg) / avg;
  const pct = Math.round(Math.abs(diff) * 100);
  if (diff < -band) {
    return { tone: "good", label: `${pct}% below avg`, short: "Below avg",
             bg: "#ECFDF5", border: "#34D399", text: "#065F46" };
  }
  if (diff > band) {
    return { tone: "high", label: `${pct}% above avg`, short: "Above avg",
             bg: "#FEF2F2", border: "#FCA5A5", text: "#991B1B" };
  }
  return null; // within the neutral band → no sticker
};


// Build a direct deep-link to a retailer's product/search by its item number.
export const storeLink = (store, num) => {
  if (!num) return null;
  const s = (store || "").toLowerCase();
  const q = encodeURIComponent(String(num));
  if (s.includes("costco")) return `https://www.costco.com/CatalogSearch?keyword=${q}`;
  if (s.includes("walmart")) return `https://www.walmart.com/search?q=${q}`;
  if (s.includes("sam")) return `https://www.samsclub.com/search?searchTerm=${q}`;
  if (s.includes("target")) return `https://www.target.com/s?searchTerm=${q}`;
  return `https://www.google.com/search?q=${encodeURIComponent((store || "") + " item " + num)}`;
};
